import React, { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { PrimaryBlueButton, SecondaryButton } from "nvent-web/components/Button";

import Modal, { ModalProps } from "..";
import style from "./ConfirmationModal.module.scss";

interface ConfirmationProps {
  title: ReactNode;
  description: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
}

interface ConfirmationModalProps extends ModalProps, ConfirmationProps {}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  description,
  onCancel,
  onConfirm,
  ...modalProps
}) => (
  <Modal {...modalProps}>
    <h3 className={style.title}>{title}</h3>
    <p className={style.description}>{description}</p>
    <div className={style.actions}>
      <SecondaryButton className={style.cancelBtn} onClick={onCancel}>
        <FormattedMessage id="actions.cancel" />
      </SecondaryButton>
      <PrimaryBlueButton className={style.yesBtn} onClick={onConfirm}>
        <FormattedMessage id="actions.yes" />
      </PrimaryBlueButton>
    </div>
  </Modal>
);

export default ConfirmationModal;
